<template>

    <div class="chart-container swiper-chart"
      v-bind:class="'color-' + opts.swiper.buttonDesign + ' swiper-' + opts.swiper.displayMode">

      <h2 class="chart-question" v-if="opts.options.showQuestion">{{chartData.label}}</h2>
      <!-- FILTER -->
      <div class="chart-filter-container">
        <div class="chart-filter-wrapper">
          <span>{{translations.sortedBy}}:</span>
          <a class="chart-filter-like"
            v-bind:style="`
              background-color: #${opts.swiper.buttonGoodBackground};
            `"
            v-on:click="sort('like')">
            <!-- SVG need a "background" to change the color of it -->
            <!-- <div class="swiper-icon" style="-webkit-mask: url(//files.qualifio.com/static/common/css_images/icons-swiper/top-good.svg);background: yellow;"></div> -->
            <div class="swiper-icon" v-bind:style="goodIcon"
            ></div>
          </a>
          <a class="chart-filter-unlike"
            v-bind:style="`
              background-color: #${opts.swiper.buttonBadBackground};
            `"
            v-on:click="sort('unlike')">
            <div class="swiper-icon" v-bind:style="badIcon"></div>
          </a>
        </div>
      </div>

      <ul class="chart-list">
        <li v-for="answer in chartData.answersData" v-bind:key="answer.answerId">
          <!-- CHART -->
          <div class="chart-horizontal">
            <div class="chart-rank">
              <h3>#{{answer.index}}</h3>
            </div>
            <div class="chart-picture-container" v-if="opts.options.showIllustrations && answer.picture">
              <img :src="`${answer.picture}`" :alt="`${answer.pictureAlt || ''}`" class="chart-picture" />
            </div>
            <div class="chart-middle">
              <div class="chart-label">
                <h3 class="title" v-html="answer.label"></h3>
                <p class="subtitle" v-if="answer.sublabel">{{answer.sublabel}}</p>
              </div>
              <!-- Bar Good -->
              <div class="chart-bar-value">
                <div class="chart-bar-container">
                  <div class="chart-bar chart-like"
                    v-bind:style="`
                      width: ${answer.result.percents[1]}%;
                      background-color: #${opts.swiper.buttonGoodBackground} !important;
                    `"
                    >
                      <!-- SVG need a "background" to change the color of it -->
                      <div class="swiper-icon" v-bind:style="goodIcon"></div>
                    </div>
                </div>
                <div class="chart-value" v-if="opts.options.showVotesByAnswer">
                  <div class="chart-value-container">
                    <div class="chart-percentage">
                      <span>{{answer.result.percents[1]}}%</span>
                    </div>
                    <div class="chart-number">
                      <span>{{answer.result.right}}</span>
                      <span v-if="answer.result.right > 1">{{translations.votes}}</span>
                      <span v-else-if="answer.result.right <= 1">{{translations.vote}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Bar Bad -->
              <div class="chart-bar-value">
                <div class="chart-bar-container">
                  <div class="chart-bar chart-unlike"
                  v-bind:style="`
                      width: ${answer.result.percents[0]}%;
                      background-color: #${opts.swiper.buttonBadBackground} !important;
                    `"
                  >
                    <!-- For simple pictures : png, jpg, gif we only need a background-image -->
                    <div class="swiper-icon" v-bind:style="badIcon"></div>
                  </div>
                </div>
                <div class="chart-value" v-if="opts.options.showVotesByAnswer">
                  <div class="chart-value-container">
                    <div class="chart-percentage">
                      <span>{{answer.result.percents[0]}}%</span>
                    </div>
                    <div class="chart-number">
                      <span>{{answer.result.left}}</span>
                      <span v-if="answer.result.left > 1">{{translations.votes}}</span>
                      <span v-else-if="answer.result.left <= 1">{{translations.vote}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-participant-vote" v-if="answer.answered">
                <!-- <div v-if="answer.answered" class="swiper-participant-vote-container">
                  <span class="label-vote">{{translations.yourVote}}:</span>
                  <span v-bind:class="voted-container {
                    'voted-like': answer.answered === 'right',
                    'voted-unlike': answer.answered === 'left'
                  }"> -->
                  <div class="swiper-participant-vote-container">
                    <span class="label-vote">{{translations.yourVote}}:</span>
                    <span v-bind:class="{
                      'voted-container': true,
                      'voted-like': answer.answered === 'right',
                      'voted-unlike': answer.answered === 'left'
                    }" v-if="answer.answered === 'right'">
                      <div class="swiper-icon" v-bind:style="goodIcon"></div>
                    </span>

                    <span v-bind:class="{
                      'voted-container': true,
                      'voted-like': answer.answered === 'right',
                      'voted-unlike': answer.answered === 'left'
                    }" v-if="answer.answered === 'left'">
                      <div class="swiper-icon" v-bind:style="badIcon"></div>
                    </span>
                  </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
</template>

<script>
import { calculateTotalPercent } from '../../helpers/percentagesTo100'

export default {
  name: 'Swiper',
  props: ['chartData', 'translations', 'opts'],
  data: function () {
    return {
      goodIcon: {},
      badIcon: {},
      votedColor: '6db33a'
    }
  },
  methods: {
    constructIconStyle: function (icon, backgroundColor) {
      const extension = icon.slice(-3)
      if (extension === 'svg') {
        return { '-webkit-mask': `url(${icon})`, 'background': '#' + backgroundColor }
      }
      return { 'backgroundImage': `url(${icon})` }
    },
    dynamicIcons: function () {
      this.goodIcon = this.constructIconStyle(this.opts.swiper.iconGood, this.opts.swiper.buttonGoodColor)
      this.badIcon = this.constructIconStyle(this.opts.swiper.iconBad, this.opts.swiper.buttonBadColor)
    },
    resizeAndSetDivHeight: function () {
      const divs = document.getElementsByClassName('chart-picture-container')
      if (!divs[0]) return
      var w = divs[0].offsetWidth

      for (var i = 0; i < divs.length; i++) {
        if (w !== 0) {
          divs[i].style.height = w + 'px'
        }
      }
    },
    sort: function (direction) {
      const index = direction === 'like' ? 1 : -1
      this.chartData.answersData.sort((a, b) => {
        if (a.index > b.index) {
          return index
        } else if (a.index < b.index) {
          return -index
        }
        return 0
      })
    }
  },
  created () {
    for (let i = 0; i < this.chartData.answersData.length; i++) {
      const left = this.chartData.answersData[i].result['left']
      const right = this.chartData.answersData[i].result['right']
      const percentLeft = left !== 0 ? (left / (left + right)) * 100 : 0
      const percentRight = right !== 0 ? (right / (left + right)) * 100 : 0
      const totalPercent = percentLeft + percentRight === 0 ? 0 : 100
      this.chartData.answersData[i].result.percents = calculateTotalPercent([percentLeft, percentRight], totalPercent)
    }
  },
  mounted () {
    var that = this
    that.resizeAndSetDivHeight()
    window.onresize = function (event) {
      that.resizeAndSetDivHeight()
    }
    this.dynamicIcons()
  }
}
</script>

<style scoped src="../../assets/css/chart-swiper.css">

</style>



// WEBPACK FOOTER //
// src/components/charts/Swiper.vue